import { ActionCardModel } from '@playbooks/action-cards-utils/src'

import StaticReplacementsProcessor from '../webPlayTitleReplacementsProcessors/StaticReplacementsProcessor'
import ActionCardReplacementsProcessor from '../webPlayTitleReplacementsProcessors/ActionCardReplacementsProcessor'

const WEB_PLAY_TITLE_DEFAULT_TEMPLATE = '$PlayTerm from $Sender'

export default class WebPlayTitleGenerator {
  playTerm: string
  senderEmail: string
  actionCardModel: ActionCardModel

  constructor(playTerm: string, senderEmail: string, actionCardModel: ActionCardModel) {
    this.playTerm = playTerm
    this.senderEmail = senderEmail
    this.actionCardModel = actionCardModel
  }

  generateTitle(template: string | null) {
    let result = template || WEB_PLAY_TITLE_DEFAULT_TEMPLATE
    for (const processor of this.getReplacementsProcessors()) {
      result = processor.process(result)
    }
    return result
  }

  *getReplacementsProcessors() {
    yield new StaticReplacementsProcessor(this.playTerm, this.senderEmail)
    yield new ActionCardReplacementsProcessor(this.actionCardModel)
  }
}
